import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';

import {CART_PAY_LATER_LEARN_MORE} from 'constants/analytics/events/cart';
import {PayOverTimeLocations} from 'constants/payOverTime';

/**
 * Analytics for PayOverTimePopup
 */
export const sendAnalytics = (location: PayOverTimeLocations, payLaterMethod: string) => {
    switch (location) {
        case PayOverTimeLocations.CART:
        case PayOverTimeLocations.CART_REBATE:
            sendDesktopAnalyticsEvent(CART_PAY_LATER_LEARN_MORE, {
                label: payLaterMethod,
            });
            break;
        default:
            break;
    }
};
